import CatalogEntity from "../Components/CatalogEntity";
import {renderColumnValue} from "../../../General/SharedMethods";
import {Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField} from "@mui/material";
import * as yup from 'yup';

const ManufacturerEditor = ({enums}) => {

    const ViewManufacturerDialog = (columns, viewRow, setViewRow) => {
        const components = [];
        for (let i = 0; i < columns.length; i += 1) {
            components.push(
                <Grid container spacing={2} marginBottom={1} padding={1} key={`row-${i}`}>
                    {[...Array(1)].map((_, j) => {
                        const column = columns[i + j];
                        return column && (
                            <Grid item xs={12} key={column.accessorKey}>
                                <TextField
                                    label={column.header}
                                    defaultValue={renderColumnValue(column, viewRow, enums)}
                                    InputProps={{
                                        readOnly: true,
                                    }}
                                    variant="standard"
                                    fullWidth
                                />
                            </Grid>
                        );
                    })}
                </Grid>
            );
        }

        return (
            <Dialog maxWidth="md" open={true}>
                <DialogTitle variant="h4">View Details</DialogTitle>
                <DialogContent>
                    {components}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setViewRow(null)}>Close</Button>
                </DialogActions>
            </Dialog>
        );
    };

    const createManufacturerColumns = (validationErrors, setValidationErrors) => {
        return [
            {
                accessorKey: 'id',
                header: 'Id',
                enableEditing: false,
                muiEditTextFieldProps: {
                    type: 'select',
                    required: true,
                    error: !!validationErrors?.id,
                    helperText: validationErrors?.id,
                    hidden: true,
                    onFocus: () =>
                        setValidationErrors({
                            ...validationErrors,
                            id: undefined,
                        }),
                },
            },
            {
                accessorKey: 'name',
                header: 'Name',
                muiEditTextFieldProps: {
                    type: 'text',
                    required: true,
                    error: !!validationErrors?.name,
                    helperText: validationErrors?.name,
                    onFocus: () =>
                        setValidationErrors({
                            ...validationErrors,
                            name: undefined,
                        }),
                },
            },
            {
                accessorKey: 'url',
                header: 'URL',
                Cell: ({row}) => <a href={row.original.url}>{row.original.url}</a>,
                muiEditTextFieldProps: {
                    type: 'text',
                    required: true,
                    error: !!validationErrors?.url,
                    helperText: validationErrors?.url,
                    onFocus: () =>
                        setValidationErrors({
                            ...validationErrors,
                            url: undefined,
                        }),
                },
            }
        ]
    }

    const manufacturerValidationSchema = yup.object().shape({
        name: yup.string().required('Name is required').max(255, 'Name must be no longer than 255 characters'),
        url: yup.string().url('URL must be a valid URL').required('URL is required').max(255, 'URL must be no longer than 255 characters'),
    });

    return (
        <CatalogEntity entityType={'manufacturers'}
                       entityName={'Manufacturer'}
                       createColumns={createManufacturerColumns}
                       validationSchema={manufacturerValidationSchema}
                       customViewDialog={ViewManufacturerDialog}
                       enums={enums}
        />
    )
}

export default ManufacturerEditor;
